/**
 * Public entry for the referral promotions campaign.
 * Prefer importing from `@cont/ReferralPromotions` (this file) only.
 */
export { default } from './ReferralPromotions';
export {
  CampaignInvalidScreenError,
  fetchCampaignCms,
  fetchCampaignState,
  isCampaignScreenTypeActive
} from './api';
export {
  REFERRAL_PROMOTIONS_CMS_PATH,
  REFERRAL_PROMOTIONS_FEATURE_TAG,
  REFERRAL_PROMOTIONS_PAGE_PATH,
  REFERRAL_PROMOTIONS_STATIC_IMAGES
} from './feature';
